import { useLocalStorageManager } from '@0x234/common-vue/storage/local-storage-manager';
import { RequestManager } from '@jaseeey/request-manager';
import { defineStore } from 'pinia';

export const usePublicInviteLinkStore = defineStore('public-invite-link', () => {
    const localStorageManager = useLocalStorageManager();

    const inviteLinkToken = localStorageManager.storeRef('invite-link/referrerToken', null);

    async function validateInviteLinkToken(token) {
        await RequestManager.call(this.$api, 'get', `/v1/public/invite-links/${token}`, null, {}, () => {
            inviteLinkToken.value = token;
        }, err => {
            inviteLinkToken.value = null;
            throw err;
        });
    }

    return {
        inviteLinkToken,
        validateInviteLinkToken
    };
});
